<template>
    <v-dialog
        v-model="dialog"  
        persistent 
        scrollable
        max-width="1000px"
        transition="dialog-transition">
        <template v-slot:activator="{ on:dialog }">
            <v-tooltip top>
                <template v-slot:activator="{ on:tooltip }">
                    <v-btn class="white--text pl-2" @click="getDocumentos" color="#0B3F67" v-on="{ ...tooltip, ...dialog }" >Repositorio<v-icon right> {{icon}} </v-icon></v-btn>                   
                </template>
                {{ tooltipText }}
            </v-tooltip>
        </template>
        <v-card :loading="loading">
            <v-card-title class="pa-0">
              <ModalTitle :titulo="titulo" @cancelar="cancelar"/>
            </v-card-title> 
            <v-divider></v-divider>
            <v-card-text>
                <div class="text-h6 text-center pt-3">
                    {{ parametro }}
                </div>
                <div class="text-h6 text-center">
                    {{ anioConsulta }}
                </div>
                <div class="d-flex justify-end">
                    <div class="w-40">
                        <v-file-input 
                            accept=".png, .jpg, .jpeg"
                            show-size 
                            counter
                            multiple
                            v-model="archivos"
                            :error-messages="docErrors"
                            @change="$v.archivos.$touch()"
                            @blur="$v.archivos.$touch()"
                            :label="'Agregar Evidencias'">
                        </v-file-input>
                    </div>
                </div>
                <v-divider></v-divider>
                <div class="text-sm-subtitle-1 text-md-h6 text-center font-weight-medium pt-1 pb-1">
                    Evidencias del Repositorio
                </div>
                <v-divider></v-divider> 
                <v-data-table
                    item-key="repositorioId"
                    :headers="headers"
                    :items="documentos"
                    :items-per-page="5"
                    no-data-text="No hay documento en el Repositorio"
                    :footer-props="footer">
                    <template v-slot:item.fechaRegistro="{ item }">
                        {{ dateFormat(item.fechaRegistro) }}
                    </template>
                    <template v-slot:item.documentoId="{ item }">      
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="#0B3F67" @click="descargarDocumento(item.documentoId)">mdi-cloud-download-outline</v-icon>
                            </template>
                            Descargar
                        </v-tooltip>      
                    </template>
                    <template v-slot:item.action="{ item }">
                    <div class="d-flex flex-row">
                        <ImageViewer :documentoId="item.documentoId" />
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon 
                                    v-on="on" 
                                    class="mr-2" 
                                    color="#0B3F67" @click="borrar(item.repositorioId)">
                                        mdi-trash-can-outline
                                </v-icon>
                            </template>
                            Eliminar Evidencia
                        </v-tooltip>
                        <ModicafDoc 
                            class="mr-2" 
                            :origen="origen"
                            :documento="item.documentoId"
                            :idDocumento="item.documentoId"
                            :inst="item.instalacion"
                            @reload="getDocumentos()"/>     
                    </div>         
                    </template>
                </v-data-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" :disabled="loading" @click="cancelar" text>Cancelar</v-btn>
                <v-btn color="#0B3F67" :loading="loading" @click="argregarEvidencias" text>Agregar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import moment from "moment"
import axios from "@/axios.js"
import { required } from "vuelidate/lib/validators"
import ModalTitle from '@/components/utils/ModalTitleComponent'
import ImageViewer from '@/components/documentos/ImageViewerComponent.vue'
import ModicafDoc from "@/components/documentos/ModificarDocComponent"

//Custom validations
const maxFileSize = (files) => {
    if(files != null) {
        let maximo = files.length * (5 * 1024 * 1024);
        let total = 0;
        files.forEach(file => {
            total += file.size
        });        
        return total < maximo;
    }
    return false;
}
export default {
    created() {
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
    },  
    components: {
      ModalTitle,
      ModicafDoc,
      ImageViewer
    },
    props: [
        'titulo',
        'tooltipText',
        'tipo',
        'icon',
        'id'
    ],
    computed: {
      parametro() {
        switch(this.tipo) {
          case 1:
            return 'Educación Ambiental'
          case 2:
            return 'Acciones de Reducción'
          case 3:
            return 'Actividad de Compensación'
          case 4:
            return 'Acciones de Adaptación'
        }
      },
      origen() {
        switch(this.tipo) {
          case 1:
            return 'educacionAmbiental'
          case 2:
            return 'accionReduccion'
          case 3:
            return 'actividadCompensacion'
          case 2:
            return 'accionAdaptacion'
        }
      },
      sucursal() {
          return this.$store.getters.sucursal;
      },
      indicadorActual() {
          return this.$store.getters.indicadorActual;
      },
      usuario(){
          return this.$store.getters.usuario;
      },
      docErrors () {
          const errors = []
          if (!this.$v.archivos.$dirty) return errors            
          !this.$v.archivos.required && errors.push('Datos requeridos.')
          !this.$v.archivos.maxFileSize && errors.push('El tamaño total debe ser menor a 2 MB por archivo.')        
          return errors
      },
       anioConsulta() {
          return this. $store.getters.anioConsulta;
      },
    },
    data: () => ({
        dialog : false,
        loading: false,
        archivos: [],
        documentos: [],
        headers: [
            { 
                text: "Acciones",
                value: "action",
                align: "center",
                align: 'center',
                width: '10%',
                sortable: false
            },
            {
                text: "Nombre",
                value: "nombre",
                align: "center",
                sortable: true
            },
            {
                text: "Origen",
                value: "origen",
                align: "center",
                sortable: true
            },
            {
                text: "Fecha Registro",
                value: "fechaRegistro",
                align: "center",
                sortable: true
            },
            {
                text: "Archivo",
                align: "center",
                sortable: false,
                value: "documentoId"
            }
        ],
        footer: {
            disableItemsPerPage: true,
            showFirstLastPage: true,
            firstIcon: "mdi-page-first",
            lastIcon: "mdi-page-last",
            prevIcon: "mdi-chevron-left",
            nextIcon: "mdi-chevron-right",
            itemsPerPageText: "Registros por página",
            itemsPerPageAllText: "Todos",
            showCurrentPage: true
        }
    }),
    validations: {
        archivos: {
            required,
            maxFileSize
        }
    },
    methods: {
        argregarEvidencias() {
            this.$v.$touch();
            if(!this.$v.$invalid) {
                this.loading = true;
                let formData = new FormData();
                formData.append('parametro', this.indicadorActual);
                formData.append('instalacion', this.sucursal.id);
                this.archivos.forEach(file => {
                    formData.append('archivos', file);
                });
                formData.append('usuario', this.usuario.id)
                formData.append('anio', this.anioConsulta)
                formData.append('tipoActividad', this.tipo)
                axios.post(`/documento/agregarRepositorio`, formData)
                .then(response => {
                    this.$store.dispatch('noti',{mensaje: 'Evidencias agregadas ', color:'success'});
                    this.$emit('reload');
                    this.cancelar();
                }).catch(error => {
                  if (error.request && error.request.status === 401) {
                    this.$store.commit('showSessionDialog', true);
                  } else {
                    if (error.request && error.request.status === 415) {
                      this.$store.dispatch('noti', {mensaje: error.response.data, color: 'error'});
                      this.loading = false;
                    } else {
                      this.$store.dispatch('noti', {mensaje: 'Error en la carga de documentos', color:'error'}); 
                      this.cancelar();
                    }
                  }
                });
            }
        },
        getDocumentos() {
            this.$store.dispatch("loadingPage", true);
            axios.get(`/documento/getDataRepositorio/${this.sucursal.id}/${this.indicadorActual}/${this.anioConsulta}/${this.tipo}`).then(response => {
                this.documentos = response.data;
                this.$store.dispatch("loadingPage", false);
            }).catch(error => {
                if (error.request && error.request.status === 401) {
                this.$store.commit('showSessionDialog', true);
                } else {
                console.log("Error en la carga de documentos " + error);
                this.$store.dispatch("loadingPage", false);
                }
            });
        },
        dateFormat(fecha) {
            return fecha ? moment(fecha).format('DD/MM/YYYY') : '';
        },
        borrar(repositorioId) {
            this.$store.dispatch('confirma', {mensaje: '¿Desea eliminar el documento?', show: true})
            .then((confirm) => {
                if (confirm) {
                    this.$store.dispatch("loadingPage", true);
                    axios.delete(`/documento/eliminarRepositorio/${repositorioId}`).then(() => {
                        this.$store.dispatch("loadingPage", false);
                        this.getDocumentos()
                    }).catch(error => {
                        if (error.request && error.request.status === 401) {
                           this.$store.commit('showSessionDialog', true);
                        } else {
                            console.log("Error en la carga de documentos " + error);
                            this.$store.dispatch("loadingPage", false);
                        }
                    });
                }
            });
        },
        cancelar() {
            this.archivos = [];
            this.$v.archivos.$reset();
            this.dialog = false;
            this.loading = false;
        }
    },
}
</script>
<style scoped>
.w-40 {
    width: 40%;
}
</style>